export enum Experiment {
  EnableCollapsedView = 'spec.payments-checkout.CollapsedViewPaymentMethodsBanner',
  EnableAfterpayNewMessage = 'spec.payments-checkout.EnableAfterpayNewMessage',
}
